import React from "react";
import AsyncSelect from "react-select3/async";
import PropTypes from "prop-types";

const StatusMultiSelect = ({
  label = "Status",
  placeholder = "Select a Status",
  isMulti = true,
  name,
  values = [],
  disabled = false,
  setValues = (x) => x,
  getValues = (x) => x,
  onChange
}) => {
  const options = [
    { label: "Active", value: true },
    { label: "Inactive", value: false }
  ];

  const handleChange = (value) => {
    onChange(name, setValues(value));
  };

  return (
    <React.Fragment>
      {label ? (
        <label
          className={`control-label ${!label ? "hidden" : ""}`}
          htmlFor="customer-select"
          style={{ textTransform: "uppercase" }}
        >
          {label}
        </label>
      ) : null}
      <AsyncSelect
        id="status-select"
        name={name}
        className="react-select-container"
        classNamePrefix="react-select-container"
        placeholder={placeholder}
        disabled={disabled}
        defaultOptions={options}
        onChange={handleChange}
        isMulti={isMulti}
        styles={{
          menu: (provided) => ({
            ...provided,
            zIndex: 999
          })
        }}
        value={getValues(values)}
        noOptionsMessage={({ inputValue }) =>
          inputValue.length ? "No options" : "Start typing..."
        }
      />
    </React.Fragment>
  );
};

StatusMultiSelect.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
  name: PropTypes.string,
  values: PropTypes.array,
  disabled: PropTypes.bool,
  setValues: PropTypes.func,
  getValues: PropTypes.func,
  onChange: PropTypes.func
};

export default StatusMultiSelect;
